import { useEffect } from "react";

import { LinearProgress } from "./LinearProgress";

interface RedirectToLoginProps {
    fresh?: boolean;
}

export const RedirectToLogin =  (props: RedirectToLoginProps) => {
    const { fresh } = props;

    useEffect(() => {
        const loginPage = "https://login.gogogarden.dk";

        const isProduction = window.location.hostname === "web.gogogarden.dk";
        if ( fresh && isProduction ) return window.location.replace(loginPage);

        const returnUrl = fresh ? window.location.origin : window.location.href;
        window.location.replace(`${loginPage}?returnUrl=${returnUrl}`);
    }, [fresh]);

    return <LinearProgress />;
};
